import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PurchaseOrderOutline } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0572. 以降のプロジェクト（費用）一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/next_purchase_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const nextPurchaseOrders = (props: Props): Promise<PurchaseOrderOutline[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/next_purchase_orders`
  );
};

export const useNextPurchaseOrders = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => nextPurchaseOrders(props),
  });
};

export const useInvalidateNextPurchaseOrders = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) }).then((r) => {});
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.id, 'next_purchase_orders'];
};
